export enum ImportsTypesEnum {
  ALL = 'all',
  ALL_BUSSINESS = 'allBusiness',
  EXISTENT = 'existent',
  EXISTENT_BUSINESS = 'existentBusiness',
  NEW = 'new',
  NEW_BUSINESS = 'newBusiness'
}
